import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  pageContainer: theme => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${theme.spacing.xs};
  `,

  alertContainer: theme => css`
    width: 100%;
    margin-top: ${theme.spacing.xxs};
    .mantine-Alert-root {
      width: 100%;
    }
    .mantine-Alert-icon {
      margin-top: 0;
    }
    .mantine-Alert-message {
      div {
        margin-top: 0;
      }
    }
    @media (max-width: ${theme.grid.breakpoint.sm}) {
      .mantine-Alert-title {
        margin: 0px 0px 0.1rem;
      }
      button {
        height: ${theme.spacing.sm};
      }
    }
  `,

  title: theme => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.xxs};
  `,

  tabsContainer: css`
    width: 100%;
  `,

  cardsContainer: theme => css`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    margin-bottom: ${theme.spacing.xxs};
    width: 100%;
    gap: ${theme.spacing.xs};
    @media (min-width: ${theme.grid.breakpoint['2xl']}) {
      ::-webkit-scrollbar {
        width: ${theme.spacing.xxs};
      }
      ::-webkit-scrollbar-track {
        background-color: ${theme.colors.background.gray};
      }
      ::-webkit-scrollbar-thumb {
        background-color: ${theme.colors.neutral[100]};
        border-radius: ${theme.border.radius.lg};
      }
    }
  `,

  container: css`
    width: 100%;
    display: flex;
    flex-direction: column;
  `,

  containerIlustration: theme => css`
    margin-top: ${theme.spacing.md};
    padding: ${theme.spacing.sm};
    justify-self: center;
    align-content: center;
  `,

  containerAllActiveAccounts: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `,
})

export { useStyles }
